import { Button } from '../ui/button';
import { Label } from '../ui/label';
import { Input } from '../ui/input';
import { Textarea } from '../ui/textarea';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../ui/select';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from '../ui/dialog';
import { Edit, Trash2 } from 'lucide-react';

/** Dialog appuntamento: vista dettaglio (view) o form (create/edit). Lo stato vive nel parent. */
export default function AppuntamentoDialog({
  open, onOpenChange, dialogMode, selectedAppuntamento,
  formData, setFormData, tecnici,
  clienteSearch, clienteSearchResults, selectedCliente,
  onClienteSearch, onSelectCliente, onResetCliente,
  onSubmit, onDelete, onEdit,
}) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-lg rounded-none">
        <DialogHeader>
          <DialogTitle className="font-black">
            {dialogMode === 'create' ? 'Nuovo Appuntamento' :
             dialogMode === 'edit' ? 'Modifica Appuntamento' : 'Dettaglio Appuntamento'}
          </DialogTitle>
        </DialogHeader>

        {dialogMode === 'view' && selectedAppuntamento ? (
          <div className="space-y-4">
            <div className="p-4 rounded" style={{
              backgroundColor: `${selectedAppuntamento.tecnico_colore}10`,
              borderLeft: `4px solid ${selectedAppuntamento.tecnico_colore}`
            }}>
              <h3 className="font-bold text-xl">{selectedAppuntamento.titolo}</h3>
              <p className="text-muted-foreground">{selectedAppuntamento.descrizione}</p>
            </div>

            <div className="grid grid-cols-2 gap-4 text-sm">
              <div>
                <Label className="text-xs text-muted-foreground">DATA</Label>
                <p className="font-medium">{selectedAppuntamento.data}</p>
              </div>
              <div>
                <Label className="text-xs text-muted-foreground">ORARIO</Label>
                <p className="font-medium">{selectedAppuntamento.ora_inizio} - {selectedAppuntamento.ora_fine || '-'}</p>
              </div>
              <div>
                <Label className="text-xs text-muted-foreground">TECNICO</Label>
                <p className="font-medium" style={{ color: selectedAppuntamento.tecnico_colore }}>
                  {selectedAppuntamento.tecnico_nome || '-'}
                </p>
              </div>
              <div>
                <Label className="text-xs text-muted-foreground">CLIENTE / CONTATTO</Label>
                <p className="font-medium">{selectedAppuntamento.cliente_nome || selectedAppuntamento.nome_contatto || '-'}</p>
              </div>
              {selectedAppuntamento.telefono_contatto && (
                <div className="col-span-2">
                  <Label className="text-xs text-muted-foreground">TELEFONO CONTATTO</Label>
                  <p className="font-medium">{selectedAppuntamento.telefono_contatto}</p>
                </div>
              )}
              {selectedAppuntamento.luogo && (
                <div className="col-span-2">
                  <Label className="text-xs text-muted-foreground">LUOGO</Label>
                  <p className="font-medium">{selectedAppuntamento.luogo}</p>
                </div>
              )}
              {selectedAppuntamento.note && (
                <div className="col-span-2">
                  <Label className="text-xs text-muted-foreground">NOTE</Label>
                  <p className="font-medium">{selectedAppuntamento.note}</p>
                </div>
              )}
            </div>

            <div className="flex gap-2 pt-4">
              <Button variant="outline" onClick={() => onEdit(selectedAppuntamento)} className="rounded-none flex-1">
                <Edit className="h-4 w-4 mr-2" /> Modifica
              </Button>
              <Button variant="destructive" onClick={() => onDelete(selectedAppuntamento.id)} className="rounded-none">
                <Trash2 className="h-4 w-4" />
              </Button>
            </div>
          </div>
        ) : (
          <div className="space-y-4">
            <div>
              <Label className="text-xs font-mono uppercase">Titolo *</Label>
              <Input
                value={formData.titolo}
                onChange={(e) => setFormData({...formData, titolo: e.target.value})}
                placeholder="Es: Installazione registratore"
                className="rounded-none"
              />
            </div>

            <div className="grid grid-cols-3 gap-4">
              <div>
                <Label className="text-xs font-mono uppercase">Data *</Label>
                <Input
                  type="date"
                  value={formData.data}
                  onChange={(e) => setFormData({...formData, data: e.target.value})}
                  className="rounded-none"
                />
              </div>
              <div>
                <Label className="text-xs font-mono uppercase">Ora Inizio *</Label>
                <Input
                  type="time"
                  value={formData.ora_inizio}
                  onChange={(e) => setFormData({...formData, ora_inizio: e.target.value})}
                  className="rounded-none"
                />
              </div>
              <div>
                <Label className="text-xs font-mono uppercase">Ora Fine</Label>
                <Input
                  type="time"
                  value={formData.ora_fine}
                  onChange={(e) => setFormData({...formData, ora_fine: e.target.value})}
                  className="rounded-none"
                />
              </div>
            </div>

            <div>
              <Label className="text-xs font-mono uppercase">Tecnico/Operatore</Label>
              <Select
                value={formData.tecnico_id || 'none'}
                onValueChange={(v) => setFormData({...formData, tecnico_id: v === 'none' ? '' : v})}
              >
                <SelectTrigger className="rounded-none" data-testid="appuntamento-tecnico-select">
                  <SelectValue placeholder="Seleziona tecnico (opzionale)" />
                </SelectTrigger>
                <SelectContent className="rounded-none">
                  <SelectItem value="none">
                    <span className="text-muted-foreground">— Nessun tecnico —</span>
                  </SelectItem>
                  {tecnici.map((t) => (
                    <SelectItem key={t.id} value={t.id}>
                      <div className="flex items-center gap-2">
                        <span className="w-3 h-3 rounded-full" style={{ backgroundColor: t.colore || '#3b82f6' }}></span>
                        {t.nome} {t.cognome}
                      </div>
                    </SelectItem>
                  ))}
                </SelectContent>
              </Select>
            </div>

            <div>
              <Label className="text-xs font-mono uppercase">Cliente (cerca per nome o P.IVA)</Label>
              <div className="relative">
                <Input
                  value={clienteSearch}
                  onChange={(e) => onClienteSearch(e.target.value)}
                  placeholder="Digita nome cliente o P.IVA..."
                  className="rounded-none"
                  data-testid="appuntamento-cliente-search"
                />
                {selectedCliente && (
                  <button
                    type="button"
                    onClick={onResetCliente}
                    className="absolute right-2 top-1/2 -translate-y-1/2 text-muted-foreground hover:text-foreground"
                  >
                    ×
                  </button>
                )}

                {clienteSearchResults.length > 0 && (
                  <div className="absolute z-50 w-full mt-1 bg-background border border-border shadow-lg max-h-60 overflow-y-auto">
                    <div className="p-2 text-xs text-muted-foreground border-b bg-muted">
                      CLICCA PER SELEZIONARE:
                    </div>
                    {clienteSearchResults.map((c) => (
                      <div
                        key={c.id}
                        className="p-3 hover:bg-primary/10 cursor-pointer border-b border-border/50 last:border-0"
                        onClick={() => onSelectCliente(c)}
                      >
                        <div className="font-medium">{c.ragione_sociale}</div>
                        <div className="text-xs text-muted-foreground">
                          P.IVA: {c.partita_iva || '-'} | {c.citta_legale || c.citta || '-'}
                        </div>
                      </div>
                    ))}
                  </div>
                )}

                {clienteSearch.length >= 2 && clienteSearchResults.length === 0 && !selectedCliente && (
                  <div className="absolute z-50 w-full mt-1 bg-background border border-border p-3 text-sm text-muted-foreground">
                    Nessun cliente trovato
                  </div>
                )}
              </div>
              {selectedCliente && (
                <div className="mt-1 text-xs text-muted-foreground">
                  Selezionato: <span className="text-primary font-medium">{selectedCliente.ragione_sociale}</span>
                </div>
              )}
            </div>

            {!selectedCliente && (
              <div className="grid grid-cols-2 gap-4 p-3 border border-dashed border-border bg-muted/30">
                <div>
                  <Label className="text-xs font-mono uppercase">Contatto libero</Label>
                  <Input
                    value={formData.nome_contatto || ''}
                    onChange={(e) => setFormData({...formData, nome_contatto: e.target.value})}
                    placeholder="Es: Sig. Rossi (prospect)"
                    className="rounded-none"
                    data-testid="appuntamento-nome-contatto"
                  />
                </div>
                <div>
                  <Label className="text-xs font-mono uppercase">Telefono</Label>
                  <Input
                    value={formData.telefono_contatto || ''}
                    onChange={(e) => setFormData({...formData, telefono_contatto: e.target.value})}
                    placeholder="Es: 333 1234567"
                    className="rounded-none"
                    data-testid="appuntamento-telefono-contatto"
                  />
                </div>
                <p className="col-span-2 text-[11px] text-muted-foreground -mt-2">
                  Facoltativo: per appuntamenti con nuovi prospect non ancora registrati come clienti
                </p>
              </div>
            )}

            <div>
              <Label className="text-xs font-mono uppercase">Luogo</Label>
              <Input
                value={formData.luogo}
                onChange={(e) => setFormData({...formData, luogo: e.target.value})}
                placeholder="Indirizzo o luogo"
                className="rounded-none"
              />
            </div>

            <div>
              <Label className="text-xs font-mono uppercase">Note</Label>
              <Textarea
                value={formData.note}
                onChange={(e) => setFormData({...formData, note: e.target.value})}
                placeholder="Note aggiuntive..."
                className="rounded-none"
                rows={3}
              />
            </div>

            <DialogFooter>
              <Button variant="outline" onClick={() => onOpenChange(false)} className="rounded-none">
                Annulla
              </Button>
              <Button onClick={onSubmit} className="rounded-none">
                {dialogMode === 'create' ? 'Crea' : 'Salva'}
              </Button>
            </DialogFooter>
          </div>
        )}
      </DialogContent>
    </Dialog>
  );
}
